var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 38,
    viewBox: "0 0 152 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 34.6623C1 35.9534 2.03319 37 3.30769 37H148.692C149.967 37 151 35.9534 151 34.6623V3.33766C151 2.04661 149.967 1 148.692 1H3.30769C2.03319 1 1 2.04661 1 3.33766V34.6623Z",
    stroke: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRail);
export default __webpack_public_path__ + "static/media/rail.ff2cd6a83ae2e6ad1d2de9fedddb1dc9.svg";
export { ForwardRef as ReactComponent };